import React, { useState } from 'react'
import TableHeaderBetting from '../../components/control/table/table_header_betting'
import strings from '../../lang/strings'
import {
    customDateFormat,
    formatNumber,
    string,
} from '../../helper/common'
import TableCell from '../../components/control/table/table_cell'
import TableCellBettingResult from '../../components/control/table/table_cell_betting_result'

const BjResultBettingBoxComponent = ({ title, bettingDataList = [], dat_status, expectRate, expectAmount, expectCoin, expectGainRate }) => {
    const tbHeaders = [
        {
            name: strings.number,
            class: 'td-pro-betting-num',
        },
        {
            name: strings.game_date,
            class: 'td-pro-betting-game-date',
        },
        {
            name: strings.game_type,
            class: 'td-pro-game-ty',
        },
        {
            name: strings.league,
            class: 'td-pro-betting-league',
        },
        {
            name: strings.betting_line,
            class: 'td-pro-betting-line',
            is_result: true
        },
    ]
    const gameTypeList = [strings.normal, strings.handycup, strings.endover, strings.win1loss, strings.evenorodd, strings.firsthalf]
    const getGameTypeClass = (type) => {
        if (type == 1) {
          return 'color-e45a5a'
        } else if (type == 2) {
          return 'color-3a6d99'
        } else if (type == 3) {
          return 'color-9c39cf'
        } else {
          return 'color-3a3335'
        }
      }
    return (
        <>
            <div className='mt-20 fs-20 sm-fs-16 f-b color-3a3335 sm-ml-15'>{title}</div>
            <TableHeaderBetting className={'td-pro-betting-header'} headers={tbHeaders} />
            {
                bettingDataList.map((info, index) => {
                    return (
                        <div key={index} className='tb-row-betting tb-row-betting1'>
                            <TableCell
                                value={info.btm_match_seq}
                                className={tbHeaders[0].class + ' td-cell-primary'}
                                center={tbHeaders[0].center}
                                child={null}
                            />
                            <TableCell
                                value={customDateFormat(info.round_start, true)}
                                className={tbHeaders[1].class + ' whitespace-pre-line td-cell-primary'}
                                center={tbHeaders[1].center}
                                child={null}
                            />
                            <TableCell
                                value={gameTypeList[info.betting_type]}
                                className={tbHeaders[2].class + ' td-cell-primary'}
                                center={tbHeaders[2].center}
                                child={
                                    <div className={'w-100 text-center fs-16 sm-fs-14 f-m ' + getGameTypeClass(info.betting_type)}>{gameTypeList[info.betting_type]}</div>
                                }
                            />
                            <TableCell
                                value={info.league_name}
                                className={tbHeaders[3].class + ' td-cell-primary'}
                                center={tbHeaders[3].center}
                                child={null}
                            />
                            <TableCellBettingResult
                                betting_type={info.betting_type}
                                home={info.home_name}
                                away={info.away_name}
                                winScore={info.home_dividend_rate}
                                winUp={info.prev_home_dividend_rate}
                                loseScore={info.away_dividend_rate}
                                loseUp={info.prev_away_dividend_rate}
                                drawScore={info.no_odds}
                                drawUp={info.prev_no_odds}
                                handi={info.handicap_standard}
                                uo={info.uo_standard}
                                selected={info.sel}
                                ans={info.ans}
                                className={tbHeaders[4].class + ' td-cell-primary td-cell-border'}
                                center={tbHeaders[4].center}
                                child={null}
                                onSelectChange={() => { }}
                            />
                        </div>
                    )
                })
            }

            <div className='expect-betting-result fs-18 f-b color-3a6d99 border-top-0'>{dat_status > 1 ? strings.result_betting_result : strings.expectant_betting_result}</div>
            <div className={'detail-result-info border-top-0 d-flex d-flex fs-18 sm-fs-14 f-b'}>
                <div className='d-center flex-full'>
                    <div className='d-block'>
                        <div className='d-flex'>
                            <div className='wx-120 sm-wx-74 color-3a3335'>{strings.betting_amount}</div>
                            <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectAmount))}</div>
                        </div>
                        <div className='d-flex mt-10'>
                            <div className='wx-120 sm-wx-74 color-3a3335'>{dat_status > 1 ? strings.result_amount : strings.expectant_amount}</div>
                            <div className='color-e45a5a'>{string.Format(strings.format_won, formatNumber(expectCoin))}</div>
                        </div>
                    </div>
                </div>
                <div className='d-center flex-full'>
                    <div className='d-block'>
                        <div className='d-flex'>
                            <div className='wx-120 sm-wx-74 color-3a3335'>{dat_status > 1 ? strings.result_rate : strings.expectant_rate}</div>
                            <div className='color-e45a5a'>{string.Format(strings.format_rate, expectRate)}</div>
                        </div>
                        <div className='d-flex mt-10'>
                            <div className='wx-120 sm-wx-74 color-3a3335'>{dat_status > 1 ? strings.result_gain_rate : strings.expectant_gain_rate}</div>
                            <div className='color-e45a5a'>{string.Format(strings.format_pro, formatNumber(expectGainRate))}</div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BjResultBettingBoxComponent

const BjResultBettingBoxComponentBlur = () => {
    const dummyBettingData = [
        {
            btm_match_seq: 1,
            round_start: new Date().toISOString(),
            league_name: "Premier League",
            betting_type: "Win/Loss",
            home_name: "Team A",
            away_name: "Team B",
            home_dividend_rate: 2.5,
            prev_home_dividend_rate: 2.4,
            away_dividend_rate: 1.8,
            prev_away_dividend_rate: 1.9,
            no_odds: 3.2,
            prev_no_odds: 3.3,
            handicap_standard: -1.5,
            uo_standard: 2.5,
            sel: "Home",
            ans: "Win"
        },
        {
            btm_match_seq: 2,
            round_start: new Date().toISOString(),
            league_name: "La Liga",
            betting_type: "Over/Under",
            home_name: "Team C",
            away_name: "Team D",
            home_dividend_rate: 2.7,
            prev_home_dividend_rate: 2.6,
            away_dividend_rate: 2.0,
            prev_away_dividend_rate: 2.1,
            no_odds: 3.1,
            prev_no_odds: 3.2,
            handicap_standard: -1.0,
            uo_standard: 2.8,
            sel: "Over",
            ans: "Win"
        }
    ];

    return (
        <div>
            <div className="betting-box-container" style={{ position: "relative" }}>
                <div className="blur-message">
                    스폐셜 패키지를 구매하시면 해당 영역을 보실 수 있습니다.
                </div>
                <div className={'betting-box-blur-effect'}>
                    <BjResultBettingBoxComponent
                        title="주력"
                        bettingDataList={dummyBettingData}
                        dat_status={0}
                        expectRate={2.5}
                        expectAmount={50000}
                        expectCoin={125000}
                        expectGainRate={2.5}
                    />
                </div>
            </div>
        </div>
    );
};

export { BjResultBettingBoxComponentBlur };
